import { TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

// formStyle className constant (passed to <Form formStyle={...}>) — see TaskTypeRoot wrapper.
export const TT_FORM_STYLE = 'task-types-form-style';

/** Wrapper applied around TaskTypeEditor/FieldBuilder/etc. — encapsulates Form className styles. */
export const TaskTypeRoot = styled('div')(({ theme }) => ({
  [`& .${TT_FORM_STYLE}`]: {
    maxWidth: 'none',
    [theme.breakpoints.down('sm')]: {
      '& .MuiFormControl-root': {
        width: '100%',
      },
    },
  },
}));

export const TaskTypeContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  position: 'relative',
  padding: isMobile ? 0 : theme.spacing(1),
}));

export const TaskTypeTable = styled('div')({
  width: '100%',
  '& table': { width: '100%' },
  '& tr': { cursor: 'pointer' },
});

export const EditorContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 4),
  maxWidth: 800,
  margin: '0 auto',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 1.5),
    maxWidth: '100%',
    overflowX: 'hidden',
  },
}));

export const Section = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    overflowX: 'auto',
  },
}));

// Fields table
export const FieldsHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  fontSize: '13px !important',
  borderBottom: `2px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(0.5),
}));

export const FieldsRow = styled(TableRow)(({ theme }) => ({
  '& td': {
    fontSize: 14,
    padding: theme.spacing(0.5, 1),
  },
}));

export const DragHandle = styled('span')(({ theme }) => ({
  color: theme.palette.text.disabled,
  cursor: 'grab',
  display: 'flex',
  alignItems: 'center',
}));

export const TypeLabel = styled('span')(({ theme }) => ({
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: '0.5px',
  color: theme.palette.text.secondary,
}));

export const TypeLabelDisabled = styled('span')(({ theme }) => ({
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: '0.5px',
  color: theme.palette.text.disabled,
}));

export const ActionIcons = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
});

export const AddFieldBtn = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const CloseoutRow = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 4,
  padding: theme.spacing(1, 2),
}));

export const FieldPickerGrid = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
}));

export const ConfigForm = styled('div')(({ theme }) => ({
  minWidth: 400,
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    minWidth: 'unset',
    width: '100%',
  },
}));

export const FloatingButtons = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(4),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(1),
  zIndex: 1300,
  [theme.breakpoints.down('sm')]: {
    bottom: theme.spacing(2),
    width: 'calc(100% - 32px)',
    justifyContent: 'center',
  },
}));

// Note: the original `cancelBtn` style added grey background + hover. We pass it via the
// Use global Button `color` / `variant` props (MUI standard) at call sites.
